import type { FormGridSpan } from '../form-grid/form-grid.js';

import type { FieldKind, FormFieldSurface } from './field-kind.js';

interface SpanPair {
  page: FormGridSpan;
  drawer: FormGridSpan;
  drawerSm: FormGridSpan;
}

const FIELD_SPANS: Record<FieldKind, SpanPair> = {
  cep: { page: 4, drawer: 6, drawerSm: 5 },
  uf: { page: 2, drawer: 3, drawerSm: 3 },
  city: { page: 6, drawer: 6, drawerSm: 6 },
  document: { page: 6, drawer: 6, drawerSm: 6 },
  rg: { page: 3, drawer: 3, drawerSm: 3 },
  plate: { page: 4, drawer: 12, drawerSm: 12 },
  sku: { page: 4, drawer: 6, drawerSm: 6 },
  name: { page: 12, drawer: 12, drawerSm: 12 },
  legalName: { page: 12, drawer: 12, drawerSm: 12 },
  tradeName: { page: 12, drawer: 12, drawerSm: 12 },
  street: { page: 9, drawer: 8, drawerSm: 8 },
  neighborhood: { page: 7, drawer: 4, drawerSm: 4 },
  complement: { page: 5, drawer: 8, drawerSm: 8 },
  number: { page: 3, drawer: 4, drawerSm: 4 },
  reference: { page: 12, drawer: 12, drawerSm: 12 },
  textarea: { page: 12, drawer: 12, drawerSm: 12 },
  personType: { page: 6, drawer: 6, drawerSm: 6 },
  brand: { page: 6, drawer: 6, drawerSm: 6 },
  model: { page: 6, drawer: 6, drawerSm: 6 },
  chassis: { page: 6, drawer: 12, drawerSm: 12 },
  nickname: { page: 6, drawer: 12, drawerSm: 12 },
  channel: { page: 4, drawer: 6, drawerSm: 6 },
  contactValue: { page: 8, drawer: 6, drawerSm: 6 },
  owner: { page: 12, drawer: 12, drawerSm: 12 },
  full: { page: 12, drawer: 12, drawerSm: 12 },
  color: { page: 4, drawer: 5, drawerSm: 5 },
  year: { page: 3, drawer: 4, drawerSm: 4 },
  date: { page: 4, drawer: 5, drawerSm: 5 },
  serviceCode: { page: 4, drawer: 5, drawerSm: 5 },
  duration: { page: 4, drawer: 5, drawerSm: 5 },
  taxonomy: { page: 6, drawer: 6, drawerSm: 6 },
  readOnly: { page: 6, drawer: 6, drawerSm: 6 },
  gender: { page: 3, drawer: 4, drawerSm: 4 },
  mileage: { page: 4, drawer: 5, drawerSm: 5 },
  occupation: { page: 6, drawer: 6, drawerSm: 6 },
  jobTitle: { page: 6, drawer: 6, drawerSm: 6 },
  phone: { page: 6, drawer: 6, drawerSm: 6 },
};

// 12-col grid placement per FieldKind + surface (page / drawer / drawerSm).
export function resolveFieldSpan(kind: FieldKind, surface: FormFieldSurface): FormGridSpan {
  const pair = FIELD_SPANS[kind];
  switch (surface) {
    case 'page':
      return pair.page;
    case 'drawer':
      return pair.drawer;
    case 'drawerSm':
      return pair.drawerSm;
  }
}
